import * as Yup from 'yup';

const MaterialItemSchema = Yup.object().shape({
  actId: Yup.string().required('Please Enter Activity Code'),
  plantId: Yup.string().required('Please Enter Plant Code'),
  resCode: Yup.string().required('Please Enter Resource Code'),
  ledgerId: Yup.string().required('Please Enter Ledger Code'),
  matId: Yup.string().required('Please Enter Material Code'),
  reqQty: Yup.string().required('Please Enter Quantity'),
});

export default MaterialItemSchema;
